import { Injectable, Injector } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { MsAdalAngular6Service } from '@jabilcore/microsoft-adal-angular6';
import { CognitoService } from '../cognito/cognito.service';
import { AuthService } from '../authentication/auth.service';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {

  private tokenService: MsAdalAngular6Service;

  constructor(
    private cognitoService: CognitoService,
    private authService: AuthService,
    private injector: Injector
  ) {
    if (window["loginType"] == 1)
      this.tokenService = <MsAdalAngular6Service>this.injector.get(MsAdalAngular6Service);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('assets/i18n/')) {
      return next.handle(req);
    }

    const urlBase = req.headers.get('urlBase');
    let headersNew = new HttpHeaders();


    if (window["loginType"] == 1) {
      return this.tokenService.acquireToken(urlBase).pipe(
        mergeMap((token: string) => {
          const authorizedRequest = req.clone({
            headers: headersNew.append(
              'Authorization',
              `Bearer ${token}`,
            ),
          });
          return next.handle(authorizedRequest);
        }),
      );
    }


    if (window["loginType"] == 2) {
      return this.cognitoService.getAccessToken().pipe(
        mergeMap((token: string) => {
          const authorizedRequest = req.clone({
            headers: headersNew.append('Authorization', `Bearer ${token}`),
          });
          return next.handle(authorizedRequest);
        }));
    }

    if (window["loginType"] == 3) {
      if (this.authService.tokenExpired()) {
        alert("La sesión ha expirado, por motivos de seguridad deberá iniciar sesión");
        this.authService.logAuth();
      }

      const authorizedRequest = req.clone({
        headers: headersNew.append('Authorization', `Bearer ${this.authService.token}`),
      });

      return next.handle(authorizedRequest);
    }
  }
}
